export { CataloguePage } from './src/catalogue-page';
export { CatalogDetailsPage } from './src/catalogue-details-page';
